/**
 * The `createServerFn` boundary is what lets TanStack Start's import protection tree-shake `.server.ts`
 * imports from the client bundle; the call stays in-process, hence a passthrough `validator`.
 */
import { createServerFn } from '@tanstack/react-start';
import { callTRPCProcedure } from '@trpc/server';
import { recordTrpcError, recordTrpcProcedure } from '@worldcoo/monolith/wide-events';
import { appRouter } from './trpc/router.server';
import { createTRPCContext } from './trpc/init.server';

type TRPCCallInput = { path: string; input: unknown; type: 'query' | 'mutation' };

export const trpcSSRCallFn = createServerFn({ method: 'POST' })
	.validator((input: TRPCCallInput) => input)
	.handler(async ({ data }) => {
		// `callTRPCProcedure` has no adapter hooks, so SSR procedures would carry no `rpc.method`. Accumulating,
		// because one render resolves MANY procedures inside the same wide event.
		recordTrpcProcedure({ path: data.path, type: data.type });
		try {
			return await callTRPCProcedure({
				router: appRouter,
				path: data.path,
				getRawInput: () => Promise.resolve(data.input),
				ctx: createTRPCContext(),
				type: data.type,
				signal: undefined,
				batchIndex: 0,
			});
		} catch (error) {
			recordTrpcError({ error, path: data.path });
			throw error;
		}
	});
